<h6 mat-dialog-title>{{ 'ECMR.share.title' | translate }}</h6>
<mat-dialog-content>
    <div class="tw-flex-col tw-w-full tw-h-fit tw-gap-5">
        @if (exportLink) {
            <div class="tw-flex tw-mb-4 tw-items-center">
                <mat-icon
                    matTooltip="{{
                        'ECMR.share.export-link-tooltip' | translate
                    }}"
                    class="tw-mr-0.5 tw-cursor-pointer"
                    fontSet="material-symbols-outlined">
                    info
                </mat-icon>
                <span>{{ 'ECMR.share.export-link' | translate }}</span>
                <span
                    (click)="copyExportLink()"
                    matTooltip="{{
                        'ECMR.share.copy-clipboard-export-link-tooltip'
                            | translate
                    }}"
                    class="tw-cursor-pointer tw-ml-1">
                    {{ ' ' + exportLink }}</span
                >
                <button
                    mat-icon-button
                    [matTooltip]="
                        'ECMR.share.copy-clipboard-export-link-tooltip'
                            | translate
                    "
                    (click)="copyExportLink()">
                    <mat-icon fontSet="material-symbols-outlined"
                        >content_copy</mat-icon
                    >
                </button>
            </div>
        }
        <div class="tw-grid tw-grid-cols-2 tw-w-full tw-items-center">
            <div
                class="tw-col-span-1 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-border-solid tw-border-gray-300 tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-r-1">
                {{ 'ECMR.share.choose-role' | translate }}
            </div>

            <div class="tw-col-span-1 tw-w-full tw-flex tw-justify-center">
                <div
                    class="tw-p-5 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-cursor-pointer"
                    [ngClass]="{
                        'tw-bg-[#e20074] tw-text-white':
                            shareMode === EcmrShareMode.SITE,
                    }"
                    (click)="switchShareMode(EcmrShareMode.SITE)">
                    <mat-icon
                        matPrefix
                        fontSet="material-symbols-outlined">
                        source_environment
                    </mat-icon>
                    {{ 'ECMR.share_ecmr_dialog.organization_site' | translate }}
                </div>

                <div class="tw-w-[2px]"></div>

                <div
                    class="tw-p-5 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-cursor-pointer"
                    (click)="switchShareMode(EcmrShareMode.QR_CODE)"
                    [ngClass]="{
                        'tw-bg-[#e20074] tw-text-white':
                            shareMode === EcmrShareMode.QR_CODE,
                    }">
                    <mat-icon
                        matPrefix
                        fontSet="material-symbols-outlined">
                        qr_code_scanner
                    </mat-icon>
                    {{ 'ECMR.share_ecmr_dialog.qr_code' | translate }}
                </div>
            </div>
        </div>

        <div class="tw-grid tw-grid-cols-2">
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-between tw-items-center tw-p-5 tw-border-solid tw-border-gray-300 tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-r-1">
                <div
                    [ngClass]="{
                        'active-item tw-shadow-lg':
                            selectedRole === EcmrRole.Sender,
                        'inactive-item':
                            selectedRole !== EcmrRole.Sender &&
                            shareMode !== EcmrShareMode.QR_CODE,
                        'tw-opacity-70': shareMode === EcmrShareMode.QR_CODE,
                        'tw-cursor-pointer':
                            shareMode !== EcmrShareMode.QR_CODE,
                    }"
                    (click)="selectRole(EcmrRole.Sender)"
                    class="tw-py-5 tw-rounded-lg tw-px-8 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 pulse-container">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="90"
                        height="90"
                        viewBox="0 0 36.235 34.884">
                        <defs>
                            <clipPath id="clip-path">
                                <path
                                    id="Pfad_2039"
                                    data-name="Pfad 2039"
                                    d="M12.967-5992.353H17.5v10.41a1.222,1.222,0,0,0,1.192,1.191,1.222,1.222,0,0,0,1.192-1.191v-10.41h4.529l-5.721-8.741ZM.65-5989.175l4.211,9.536,2.463-3.814,4.291,2.781a13.076,13.076,0,0,1,5.952,10.507l.008.458v2.305a1.227,1.227,0,0,0,1.035,1.181l.157.01a1.222,1.222,0,0,0,1.192-1.191v-2.305a13.069,13.069,0,0,1,5.96-10.966l4.291-2.781,2.463,3.814,4.211-9.536H26.316l2.463,3.815-4.291,2.781a15.441,15.441,0,0,0-5.8,6.993,15.522,15.522,0,0,0-5.8-6.993L8.6-5985.36l2.463-3.815Z"
                                    transform="translate(0)"
                                    fill="#002c6c"
                                    clip-rule="evenodd" />
                            </clipPath>
                            <clipPath id="clip-path-2">
                                <path
                                    id="Pfad_2038"
                                    data-name="Pfad 2038"
                                    d="M0-5963.953H38.142v-38.142H0Z"
                                    transform="translate(0 6002.094)"
                                    fill="#002c6c" />
                            </clipPath>
                        </defs>
                        <g
                            id="Gruppe_2068"
                            data-name="Gruppe 2068"
                            transform="translate(-0.65 6001.094)"
                            clip-path="url(#clip-path)">
                            <g
                                id="Gruppe_2067"
                                data-name="Gruppe 2067"
                                transform="translate(-0.383 -6002.684)"
                                clip-path="url(#clip-path-2)">
                                <path
                                    id="Pfad_2037"
                                    data-name="Pfad 2037"
                                    d="M-.35-6002.094H39.063v38.063H-.35Z"
                                    transform="translate(-0.206 6002.094)"
                                    fill="#002c6c" />
                            </g>
                        </g>
                    </svg>
                    {{ 'ECMR.share.roles.consignor' | translate }}
                </div>
                <div
                    [ngClass]="{
                        'active-item tw-shadow-lg':
                            selectedRole === EcmrRole.Carrier,
                        'inactive-item': selectedRole !== EcmrRole.Carrier,
                    }"
                    (click)="selectRole(EcmrRole.Carrier)"
                    class="tw-py-5 tw-rounded-lg tw-px-8 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-cursor-pointer">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="90"
                        height="90"
                        viewBox="0 0 32.471 23">
                        <defs>
                            <clipPath id="clip-path-3">
                                <path
                                    id="Pfad_2036"
                                    data-name="Pfad 2036"
                                    d="M24.353-5201.4v5.412h4.735v-.677a4.238,4.238,0,0,0-.2-1.284l-1.15-3.451ZM0-5208.844v15.559a4.071,4.071,0,0,0,4.059,4.06,4.978,4.978,0,0,1,.474-2.03H4.059a1.993,1.993,0,0,1-2.029-2.029v-13.529H20.971v12.176a1.04,1.04,0,0,0,1.015,1.015A1.04,1.04,0,0,0,23-5194.638v-8.117h5.682l1.488,4.4a4.924,4.924,0,0,1,.271,1.691v7.442h2.029v-7.442a6.975,6.975,0,0,0-.406-2.368l-1.691-5.074a1.018,1.018,0,0,0-.947-.676H23v-4.059Zm13.056,17.588a4.09,4.09,0,0,1,.474,2.03h7.441a4.978,4.978,0,0,1,.474-2.03Zm-4.262.676a1.358,1.358,0,0,1,1.353,1.354,1.356,1.356,0,0,1-1.353,1.353,1.356,1.356,0,0,1-1.353-1.353,1.358,1.358,0,0,1,1.353-1.354Zm16.912,0a1.358,1.358,0,0,1,1.353,1.354,1.356,1.356,0,0,1-1.353,1.353,1.356,1.356,0,0,1-1.353-1.353,1.358,1.358,0,0,1,1.353-1.354Zm-16.912-2.029a3.35,3.35,0,0,0-3.382,3.383,3.349,3.349,0,0,0,3.382,3.382,3.349,3.349,0,0,0,3.382-3.382,3.35,3.35,0,0,0-3.382-3.383Zm16.912,0a3.35,3.35,0,0,0-3.382,3.383,3.349,3.349,0,0,0,3.382,3.382,3.349,3.349,0,0,0,3.382-3.382,3.35,3.35,0,0,0-3.382-3.383Z"
                                    transform="translate(0 5208.844)"
                                    fill="#002c6c"
                                    clip-rule="evenodd" />
                            </clipPath>
                            <clipPath id="clip-path-4">
                                <path
                                    id="Pfad_2035"
                                    data-name="Pfad 2035"
                                    d="M0-5179.873H32.471v-32.471H0Z"
                                    transform="translate(0 5212.344)"
                                    fill="#002c6c" />
                            </clipPath>
                        </defs>
                        <g
                            id="Gruppe_2066"
                            data-name="Gruppe 2066"
                            clip-path="url(#clip-path-3)">
                            <g
                                id="Gruppe_2065"
                                data-name="Gruppe 2065"
                                transform="translate(0 -4.735)"
                                clip-path="url(#clip-path-4)">
                                <path
                                    id="Pfad_2034"
                                    data-name="Pfad 2034"
                                    d="M-1-5209.844H34.177v25.707H-1Z"
                                    transform="translate(-0.353 5213.226)"
                                    fill="#002c6c" />
                            </g>
                        </g>
                    </svg>

                    {{ 'ECMR.share.roles.carrier' | translate }}
                </div>
                <div
                    [ngClass]="{
                        'active-item tw-shadow-lg':
                            selectedRole === EcmrRole.Consignee,
                        'inactive-item':
                            selectedRole !== EcmrRole.Consignee &&
                            shareMode !== EcmrShareMode.QR_CODE,
                        'tw-opacity-70': shareMode === EcmrShareMode.QR_CODE,
                        'tw-cursor-pointer':
                            shareMode !== EcmrShareMode.QR_CODE,
                    }"
                    (click)="selectRole(EcmrRole.Consignee)"
                    class="tw-py-5 tw-rounded-lg tw-px-8 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-cursor-pointer">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="90"
                        height="90"
                        viewBox="0 0 36.615 35.057">
                        <defs>
                            <clipPath id="clip-path-5">
                                <path
                                    id="Pfad_2042"
                                    data-name="Pfad 2042"
                                    d="M674.023-6390.016H663.116l2.649-3.116h8.258Zm13.322,0H676.36v-3.116h8.258Zm-22.67-5.453L660-6390.016v19.477a4.687,4.687,0,0,0,4.674,4.674h10.907a12.993,12.993,0,0,1-.623-2.337H664.674a2.3,2.3,0,0,1-2.337-2.337v-17.14h11.686V-6383h2.337v-4.675h11.686v5.532a12.385,12.385,0,0,1,2.337.467v-8.336l-4.674-5.453Zm27.033,21.892a1.132,1.132,0,0,1,.078,1.636l-6.077,6.076-3.817-3.9a1.129,1.129,0,0,1,0-1.636,1.131,1.131,0,0,1,1.636,0l2.181,2.182,4.363-4.362a1.129,1.129,0,0,1,1.636,0Zm-4.83-6.311a9.741,9.741,0,0,0-9.738,9.737,9.741,9.741,0,0,0,9.738,9.738,9.741,9.741,0,0,0,9.738-9.738,9.741,9.741,0,0,0-9.738-9.737Z"
                                    transform="translate(0 0)"
                                    fill="#002c6c"
                                    clip-rule="evenodd" />
                            </clipPath>
                            <clipPath id="clip-path-6">
                                <path
                                    id="Pfad_2041"
                                    data-name="Pfad 2041"
                                    d="M660-6359.575h37.394v-37.394H660Z"
                                    transform="translate(-660 6396.969)"
                                    fill="#002c6c" />
                            </clipPath>
                        </defs>
                        <g
                            id="Gruppe_2070"
                            data-name="Gruppe 2070"
                            transform="translate(-660 6395.469)"
                            clip-path="url(#clip-path-5)">
                            <g
                                id="Gruppe_2069"
                                data-name="Gruppe 2069"
                                transform="translate(660 -6397.806)"
                                clip-path="url(#clip-path-6)">
                                <path
                                    id="Pfad_2040"
                                    data-name="Pfad 2040"
                                    d="M659-6396.469h39.731v38.174H659Z"
                                    transform="translate(-660.558 6397.248)"
                                    fill="#002c6c" />
                            </g>
                        </g>
                    </svg>

                    {{ 'ECMR.share.roles.consignee' | translate }}
                </div>
            </div>

            @if (shareMode === EcmrShareMode.SITE) {
                <div class="tw-col-span-1 tw-flex tw-flex-col tw-items-center">
                    <div>
                        <mat-form-field
                            appearance="fill"
                            class="tw-mt-3">
                            <mat-label>{{ placeHolder }}</mat-label>
                            <input
                                aria-label="searchSupplyChain"
                                [(ngModel)]="searchTerm"
                                type="text"
                                matInput
                                #input />
                            @if (!input.value) {
                                <mat-icon
                                    matPrefix
                                    fontSet="material-symbols-outlined"
                                    >search</mat-icon
                                >
                            }
                            @if (input.value) {
                                <button
                                    class="light"
                                    mat-icon-button
                                    matSuffix
                                    matTooltip="{{
                                        'OUTGOING-GOODS.NEW-BUNDLE.SUPPLY-CHAIN.TOOLTIP-DELETE-ICON'
                                            | translate
                                    }}"
                                    aria-label="Clear"
                                    (click)="
                                        input.value = ''; clearSearchFilter()
                                    ">
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        >close</mat-icon
                                    >
                                </button>
                            }
                        </mat-form-field>
                        <mat-form-field
                            appearance="fill"
                            class="">
                            <mat-label>{{
                                'ECMR.share.choose-site' | translate
                            }}</mat-label>
                            <input
                                type="text"
                                matInput
                                id="actor"
                                [(ngModel)]="actorValue"
                                disabled />
                        </mat-form-field>
                        <cdk-virtual-scroll-viewport
                            class="tw-w-full site-viewport"
                            itemSize="50">
                            <div
                                class="tw-cursor-pointer tw-h-10 tw-mb-2 tw-flex tw-items-center tw-px-3"
                                (click)="selectOrganizationSite(item)"
                                [ngClass]="
                                    alreadySharedSiteKeys.includes(item._key)
                                        ? '!tw-bg-neutral-300'
                                        : 'tw-bg-neutral-100'
                                "
                                *cdkVirtualFor="
                                    let item of currentOrganizationSites
                                        | filterSiteByName: searchTerm;
                                    let i = index
                                ">
                                <mat-icon
                                    [ngClass]="
                                        alreadySharedSiteKeys.includes(
                                            item._key
                                        )
                                            ? 'tw-visible'
                                            : 'tw-hidden'
                                    "
                                    class="tw-mr-1 tw-cursor-pointer"
                                    fontSet="material-symbols-outlined">
                                    check
                                </mat-icon>
                                {{ item.fullSiteName }}
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </div>
            }

            @if (shareMode !== EcmrShareMode.SITE) {
                <div
                    class="tw-col-span-1 tw-flex tw-flex-col tw-items-center tw-h-full">
                    <div
                        class="tw-flex tw-items-center tw-justify-center tw-h-full">
                        <div
                            class="tw-flex tw-flex-col tw-items-center tw-gap-2">
                            <qr-code
                                [value]="anonymousShareLink"
                                errorCorrectionLevel="H"
                                [margin]="2"></qr-code>
                            <button
                                matTooltip="{{
                                    'ECMR.share_ecmr_dialog.copy_link'
                                        | translate
                                }}"
                                mat-button
                                color="primary"
                                aria-label="Copy Link"
                                (click)="copyLink()">
                                <mat-icon fontSet="material-symbols-outlined"
                                    >content_copy</mat-icon
                                >
                                {{
                                    'ECMR.share_ecmr_dialog.copy_link'
                                        | translate
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-button
        mat-dialog-close>
        {{ 'OUTGOING-GOODS.CHOOSE-LOCATION-DIALOG.CANCEL' | translate }}
    </button>

    @if (shareMode === EcmrShareMode.SITE) {
        <button
            mat-raised-button
            color="primary"
            class="tw-ml-3"
            aria-label="button-confirm-supply-chain"
            [disabled]="selectedSite === null"
            (click)="confirm()">
            {{ 'ADMIN-PANEL.DIALOGS.KILL-WARNING.PROCEED' | translate }}
        </button>
    }
</mat-dialog-actions>
